import { defineMessages } from 'react-intl';

export const CallapsibleMessages = defineMessages({
  Maximize: {
    id: 'ic-collapsible-maximize',
    defaultMessage: 'Ratenrechner anzeigen',
  },
  Minimize: {
    id: 'ic-collapsible-minimize',
    defaultMessage: 'Ratenrechner minimieren',
  },
});
